import React, { useState } from "react";
import { formatPrice, formatTimeTxt, replaceNavigate } from "../../../../services/helpers/Helper";
import { METHOD_TYPE, STATUS } from "../constant";
import Confirm from "../../../shared/components/confirm";
import { URL } from "../../../../routers/constants";
import { useNavigate } from "react-router-dom";
import DeleteConfirm from "../../../shared/components/Confirm/Delete";

const LiveTr = (props) => {
   const { stt, data, onDelete } = props;
   const { campaign_name, created_at, campaign_status, customer_has_phone, comment_total_count, comments_valid_count, orders_count, revenues, campaign_type } = data;
   const [showConfirm, setShowConfirm] = useState(false);
   const navigate = useNavigate();

   const getDateTimeTxt = () => {
      let timestamp = new Date(created_at).getTime();
      return formatTimeTxt(timestamp)
   }

   const getCampaignStatus = () => {
      switch (campaign_status) {
         case STATUS.STOP_LIVE:
            return "Đã kết thúc";
         case STATUS.NOT_USE_YET:
            return "Chưa sử dụng";
         case STATUS.CRAWLING_COMPLETED:
            return "Đã dò bình luận xong";
         case STATUS.STOP_CLOSE_SALE:
            return "Đã ngừng chốt đơn";
         case STATUS.SCANNING_COMMENTS:
            return "Đang dò bình luận";
         case STATUS.LIVE:
            return "Phát trực tiếp";
         case STATUS.PROCESSED:
            return "Đã hoàn tất xử lý";
         default:
            break;
      }
   }

   const getCampaignType = () => {
      switch (campaign_type) {
         case 1:
            return "Thủ công";
         case 2:
            return "Tự động";
         case 3:
            return "Chốt đơn sau live";
         default:
            return "";
      }
   }

   const getStatusName = () => {
      switch (campaign_status) {
         case STATUS.STOP_LIVE:
            return "StopLive";
         case STATUS.NOT_USE_YET:
            return "NotUseYet";
         case STATUS.CRAWLING_COMPLETED:
         case STATUS.PROCESSED:
            return "CrawlingCompleted";
         case STATUS.STOP_CLOSE_SALE:
            return "StopCloseSale";
         case STATUS.LIVE:
            return "Live";
         default:
            break;
      }
   }

   const handleDelete = () => {
      const campaign = {
         id: data.id,
         user_id: data.user_id,
         campaign_name: data.name,
         fb_page_id: data.fb_page_id,
      }
      onDelete(campaign);
      setShowConfirm(false);
   }

   const handleOpenCampaign = (e) => {
      if (!e.target.closest('.closest')) {
         navigate(replaceNavigate(URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_EDIT, data.id));
      }
   }

   return (
      <React.Fragment>
         <tr className="app-v2-table-row" onClick={handleOpenCampaign}>
            <td className="pointer" style={{ width: 45 }}>{stt}</td>
            <td className="pointer" style={{ paddingRight: 6, maxWidth: 243 }}>
               <div className="display-flex-align-items-center cursor-pointer">
                  <div className="flex-display-col min-w-0">
                     <p title={campaign_name} className="mr-reset campaign-name title-hover">
                        {campaign_name}
                     </p>
                     <span className="date-time-txt">
                        {getDateTimeTxt()}
                     </span>
                  </div>
               </div>
            </td>
            <td className="pointer" style={{ paddingRight: 0, width: 160 }}>
               <div>
                  <div className="table-row-page-container">
                     <div className="multi-page-info-container">
                        {/* <span content="Siêu thị đồ chơi gỗ cho bé" className="app-avatar image-page-item z-index-2 app-avatar-circle app-avatar-image"
                        style={{ width: 28, height: 28, lineHeight: 28, background: 'rgb(41, 121, 255)' }}>
                        <img src="/call/social_avatar_api/profile_avatar/participants/111916578161326/channels/1/pages/111916578161326/?size=70" />
                     </span> */}
                     </div>
                  </div>
               </div>
            </td>
            <td className="pointer" style={{ paddingRight: 0, width: 160 }}>
               <span className={`campaign-status ${getStatusName()}`}>{getCampaignStatus()}</span>
            </td>
            <td className="pointer" style={{ width: 128 }}><span>{getCampaignType()}</span></td>
            <td className="text-right pointer">{formatPrice(customer_has_phone)}</td>
            <td className="text-right pointer">{formatPrice(comment_total_count)}</td>
            <td className="text-right pointer">{formatPrice(comments_valid_count)}</td>
            <td className="text-right pointer">{formatPrice(orders_count)}</td>
            <td className="text-right pointer"><span>{formatPrice(revenues)} ₫</span></td>
            <td className="text-center pointer">
               {campaign_status === STATUS.NOT_USE_YET &&
                  <div className="action-livestream-container closest" onClick={() => setShowConfirm(true)}>
                     <div className="copy-box">
                        <div className="svg-next-icon ic-trash">
                        </div>
                     </div>
                  </div>
               }
            </td>
         </tr>
         <DeleteConfirm
            isOpen={showConfirm}
            title={campaign_name}
            onConfirm={handleDelete}
            onCancel={() => setShowConfirm(false)}
         />
      </React.Fragment>
   )
}

export default LiveTr;